import { Field } from "@/shared/ui/form-field"
import { Input } from "@/shared/ui/input"
import type { EditorProps } from "../editor-props"
import { readString } from "../editor-props"
import { issuesAt } from "../issues-text"

export function CheckSubscriptionEditor({ config, onChange, issues }: EditorProps) {
	return (
		<Field
			label="Канал или группа"
			issues={issuesAt(issues, "channel")}
			hint="@username публичного канала или id вида -100…. Бота нужно добавить в канал администратором, иначе проверка пойдёт по выходу «Не удалось проверить»."
		>
			<Input
				aria-label="Канал"
				placeholder="@kmk_channel"
				value={readString(config, "channel")}
				onChange={(event) => onChange({ ...config, channel: event.target.value.trim() })}
			/>
		</Field>
	)
}
